import { insertReportToContainer, ffunc } from './supcan/dynaload';
import { Vue } from "vue-property-decorator";
import linq from 'linq';
import { Guid } from 'guid-typescript';

export interface RowAndCol {
  row: number;
  col: number;
  page?: number;
}

export interface margin {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

export class SupcanReport extends Vue {
  public AF: any;
  public AFId: string = Guid.create().toString().replace(/\-/g, '');
  public DomId: string = "";
  public suReport: any;
  /** 当前报表的URL、或者是报表的XML大串 */
  public reportFile: string = "";
  /** design=设计、view=预览 */
  public mode: string = "design";

  /** 签章图片的高 */
  private signImageHeight = 35;
  /** 签章图片的宽 */
  private signImageWidth = 90;
  /** 最后一行的高 */
  private lastRowHeight = this.signImageHeight + 1;

  private isNull(value: any) {
    if (value == null || value == '' || value == undefined) {
      return true;
    } else {
      return false;
    }
  }

  // public TagData: TagModel[] = [];
  // // Tag进行分组
  // public TagGroupData: TagGroupModel = new TagGroupModel();

  /**
   * 初始化报表容器
   * @param containerId 容器id
   * @param mode 默认design（设计模式）
   */
  public init(containerId: string, mode = 'design', callback: any = undefined, eventCallback: any = undefined) {
    let toolsStr = 'Rebar=none;PreviewButton=print;PagesTabPercent=80%';
    if (mode == 'design') {
      toolsStr = 'PagesTabPercent=70%';
    }
    else if (mode == 'design1') {
      //只有字体和打印
      toolsStr = 'Rebar=Font,Print;PreviewButton=print;PagesTabPercent=80%;';
    }
    else if (mode == 'design2') {
      //只有字体
      toolsStr = 'Rebar=Font;PreviewButton=print;PagesTabPercent=80%;';
    }
    else if (mode == 'noneBar') {
      //无标尺/工具栏/左分割条
      toolsStr = 'Rebar=none;SeperateBar=Horz;PagesTabPercent=80%;Ruler=none;PagesTabPercent=99;';
    } else if (mode == 'pay') {
      toolsStr = 'Rebar=none;PreviewButton=print,setup,export,sheets;PagesTabPercent=80%';
    }
    this.DomId = containerId;
    this.mode = mode;
    if (callback) {
      this.OnReportReady(callback);
    }
    if (eventCallback) {
      this.BindReportEvent(eventCallback);
    }
    insertReportToContainer(containerId, this.AFId, toolsStr);
    this.suReport = document.getElementById(this.AFId);
  }

  /**
   * 报表实例化后调用
   * @param callback
   */
  // public OnReportReady(callback) {
  //   (window as any).ReportReady = (id) => {
  //     if (callback) {
  //       callback(id);
  //     }
  //   }
  // }

  public OnReportReady(callback) {
    (window as any)["ReportReadyDict"][this.AFId] = (id) => {
      if (callback) {
        callback(id);
      }
    }
  }

  /**
   * 报表实例化后事件调用
   * @param callback
   */
  public BindReportEvent(callback) {
    (window as any)["ReportEventDict"][this.AFId] = (id, event, p1, p2, p3, p4) => {
      if (callback) {
        callback(id, event, p1, p2, p3, p4);
      }
    }
  }

  /**
   * 构件报表
   * @param xmlPath 报表的URL、或者是报表的XML大串
   */
  public build(xmlPath: string, callback: any = undefined) {
    this.reportFile = xmlPath;
    ffunc(this.suReport, 'Build', xmlPath);
    if (callback) {
      callback();
    }
    // const _this = this;
    // setTimeout(() => {
    //   ffunc(_this.suReport,'Build', xmlPath);
    //   if(callback) {
    //     callback();
    //   }
    // }, 1000);
  }

  /**
   * 获取所有tag绑定的信息表头表尾等
   */
  // public GetAllTagData() {
  //   this.TagData = this.getAllCellTagData();;
  //   this.TagGroupData.items = linq.from(this.TagData).where((u) => u.bindtype === 'item').toArray();
  //   this.TagGroupData.foot = linq.from(this.TagData).where((u) => u.bindtype === 'footer').toArray();
  //   this.TagGroupData.head = linq.from(this.TagData).where((u) => u.bindtype === 'header').toArray();
  //   this.TagGroupData.tables = linq.from(this.TagData).where((u) => u.bindtype === 'table').toArray();
  //   this.TagGroupData.pager = linq.from(this.TagData).where((u) => u.bindtype === 'pager').toArray();
  // }

  /**
   * 转换为XLSX文件
   * @param fileName 文件路径
   */
  public convertToXLSX(fileName: string) {
    ffunc(this.suReport, 'callfunc', `105\r\nType=XLSX; WorkSheet=all; filename=${fileName}`);
  }

  public setAutoHeight() {
    ffunc(this.suReport, 'callfunc', `404`);
  }

  /**
   * 转换为XML文件
   * @param fileName 文件路径
   */
  public convertToXML(fileName: string = '') {
    return ffunc(this.suReport, 'callfunc', `1074\r\n Filename=${fileName}`);
  }

  /**
   * 获取xml串
   */
  public getXmlStr() {
    return ffunc(this.suReport, "GetFileXML", "");
  }

  /**
   * 获取指定页的xml串
   * @param sheetIndex
   */
  public getSheetXmlStr(sheetIndex: any) {
    return ffunc(this.suReport, 'callfunc', `1074\r\n WorkSheet=${sheetIndex};isReturnContent=true;`);
  }

  /**
   * 设置列宽(单位：像素数)
   * @param colIndex
   * @param value
   * @param sheetHandle 工作表的句柄
   */
  public setColWidth(colIndex: number, value: number, sheetHandle: string = "") {
    return Number(ffunc(this.suReport, sheetHandle + 'SetColWidth', `${colIndex} \r\n ${value}`));
  }

  /**
   * 获取列宽(单位：像素数)
   * @param colIndex
   * @param value
   * @param sheetHandle 工作表的句柄
   */
  public getColWidth(colIndex: number, sheetHandle: string = "") {
    return Number(ffunc(this.suReport, sheetHandle + 'GetColWidth', `${colIndex}`));
  }

  /**
   * 设置行高(单位：像素数)
   * @param rowIndex
   * @param value
   * @param sheetHandle 工作表的句柄
   */
  public setRowHeight(rowIndex: number, value: number, sheetHandle: string = "") {
    return Number(ffunc(this.suReport, sheetHandle + 'SetRowHeight', `${rowIndex} \r\n ${value}`));
  }

  /**
   * 获取行高(单位：像素数)
   * @param rowIndex
   * @param sheetHandle 工作表的句柄
   */
  public getRowHeight(rowIndex: number, sheetHandle: string = "") {
    return Number(ffunc(this.suReport, sheetHandle + 'GetRowHeight', `${rowIndex}`));
  }

  /**
   * 获取sheet页的数量
   */
  public getWorksheets(): number {
    return Number(ffunc(this.suReport, 'GetWorksheets', ''));
  }

  /**
   * 获取当前sheet页的索引
   */
  public getCurrentWorksheet() {
    return ffunc(this.suReport, 'GetCurrentWorksheet', '');
  }

  /**
   * 设置当前工作表
   * @param sheetId 序号(从0开始计数)，或工作表名称
   */
  public setCurrentWorksheet(sheetId) {
    ffunc(this.suReport, 'SetCurrentWorksheet', `${sheetId}`);
  }

  /**
   * 设置让报表能够重画或不能重画
   * @param value
   */
  public SetRedrawAble(value: boolean) {
    ffunc(this.suReport, 'SetRedrawAble', value ? "true" : "false");
  }

  /**
   * 控件隐藏
   * @param commandStr true=隐藏;空字符串=显示
   */
  public grayWindow(commandStr: string) {
    setTimeout(() => {
      ffunc(this.suReport, 'GrayWindow', commandStr);
    }, 10);
  }

  /**
   * 获取总行数
   */
  public getRows(sheetHandle: string = ""): number {
    return Number(ffunc(this.suReport, sheetHandle + 'GetRows', ''));
  }

  /**
   * 获取总列数
   */
  public getCols(sheetHandle: string = "") {
    return Number(ffunc(this.suReport, sheetHandle + 'GetCols', ''));
  }

  /**
   * 删除行
   * @param startRowIndex 开始删除的行号(从0开始计数)
   * @param rowCount 行数，-1表示删除后面所有行
   * @param sheetHandle
   * @result 1-成功，空串-失败
   */
  public deleteRows(startRowIndex: number, rowCount: number, sheetHandle: string = "") {
    return ffunc(this.suReport, sheetHandle + 'DeleteRows', `${startRowIndex} \r\n ${rowCount}`);
  }

  /**
   * 删除列
   * @param startRowIndex 开始删除的行号(从0开始计数)
   * @param rowCount 行数，-1表示删除后面所有行
   * @param sheetHandle
   * @result 1-成功，空串-失败
   */
  public deleteCols(startColIndex: number, rowCount: number, sheetHandle: string = "") {
    return ffunc(this.suReport, sheetHandle + 'DeleteCols', `${startColIndex} \r\n ${rowCount}`);
  }

  public isRowHide(row): boolean {
    return ffunc(this.suReport, 'IsRowHide', `${row}`) > 0;
  }

  public isColHide(row): boolean {
    return ffunc(this.suReport, 'isColHide', `${row}`) > 0;
  }

  public showHideRow(row, isHide: boolean = false) {
    ffunc(this.suReport, 'HideRow', `${row} \r\n 1 \r\n ${isHide}`);
  }

  public showHideCol(col, isHide: boolean = false) {
    ffunc(this.suReport, 'HideCol', `${col} \r\n 1 \r\n ${isHide}`);
  }

  public toExcelIndex(columnName: string) {
    let index = 0;
    columnName = columnName.trim().toUpperCase();
    for (let i = 0; i < columnName.length; i++) {
      index += (this.stringToIndex(columnName.charAt(i)) - this.stringToIndex('A') + 1) * Math.pow(26, columnName.length - i - 1);
    }

    return index - 1;
  }

  public stringToIndex(str) {
    var charcode;
    return parseInt(str.toLowerCase().split('').map(function (item, i) {
      charcode = item.charCodeAt(0);
      charcode -= (charcode < 107 ? 49 : 10);
      return String.fromCharCode(charcode);
    }).join(''), 26);
  }

  /**
   * 删除高度为零的行
   */
  public clearEmptyRow() {
    const suReportSheetCount = this.getWorksheets();
    for (let i = 0; i < suReportSheetCount; i++) {
      this.setCurrentWorksheet(i);

      const rowCount = this.getRows();
      const deleteRowArray: number[] = [];
      for (let j = 0; j < rowCount; j++) {
        const height = this.getRowHeight(j);
        if (height <= 0 || this.isRowHide(j)) {
          deleteRowArray.push(j);
          this.showHideRow(j);
        }
      }

      let flag = 0;
      for (const rowIndex of deleteRowArray) {
        ffunc(this.suReport, 'DeleteRows', `${rowIndex - flag} \r\n ${1}`);
        flag++;
      }
    }
  }

  public clearEmptyCol() {
    const suReportSheetCount = this.getWorksheets();
    for (let i = 0; i < suReportSheetCount; i++) {
      this.setCurrentWorksheet(i);

      const colCount = this.getCols();
      const deleteColArray: number[] = [];
      for (let j = 0; j < colCount; j++) {
        const width = this.getColWidth(j);
        if (width <= 0 || this.isColHide(j)) {
          deleteColArray.push(j);
          this.showHideCol(j);
        }
      }

      let flag = 0;
      for (const colIndex of deleteColArray) {
        ffunc(this.suReport, 'DeleteCols', `${colIndex - flag} \rr\n ${1}`);
        flag++;
      }
    }
  }

  /**
   * 获取自定义属性
   * @param row
   * @param col
   * @param attrName
   */
  public getCellProp(row, col, attrName, sheetHandle: string = ""): string {
    if (col == null || (col == '' && typeof(col) != 'number')) {
      return ffunc(this.suReport, sheetHandle + 'GetCellProp', `${row} \r\n ${attrName}`);
    } else {
      return ffunc(this.suReport, sheetHandle + 'GetCellProp', `${row} \r\n ${col} \r\n ${attrName}`);
    }
  }

  /**
   * 取得所有内嵌对象的别名 或 ID号
   * @param commandStr 可选，类型筛选，可以是如下类型的组合(逗号分隔)：Chart、ECharts、Line、TextBox、Picture、Treelist, 分别表示统计图、百度ECharts统计图、线条、文本框、图片、树列表
   * @param strHandle 可选，格式为 range=[?];return=[?], 含义和可用值说明如下: range - 工作表范围，可用值为：full 或 all - 表示全部工作表，默认; current - 仅当前工作表；return - 返回内容，可用值为：alias - 返回别名, 默认, 注：没有别名的对象会被忽略(不在返回串中).id - 返回 ID 号，ID号是井号(#)开头的一个数字, 数字的生成规则是 (工作表顺序号 + 1) * 1000 + 对象顺序号.
   * @result 以逗号分隔的别名或ID号的串
   */
  public getGraphics(commandStr, strHandle = '') {
    return ffunc(this.suReport, strHandle + "GetGraphics", commandStr);
  }

  /**
   * 获取自定义属性
   * @param commandStr
   * @param sheetHandle
   */
  public getCellProp2(commandStr: any, sheetHandle: string = ""): string {
    return ffunc(this.suReport, sheetHandle + 'GetCellProp', `${commandStr}`);
  }

  /**
   * 设置某单元格的属性(包括自定义属性)
   * @param commandStr 命令字符串
   ** AF.func("SetCellProp", "C6 \r\n BgColor \r\n T");
   ** AF.func("SetCellProp", "C6 \r\n CustormerID \r\n 33801"); //自定义属性
   ** AF.func("SetCellProp", "C6,D7,A3:A10,MyTh \r\n TextColor \r\n Red"); //同时设置多个单元格，注："MyTh"是某个单元格的别名
   ** AF.func("SetCellProp", "C6,D7,A3:A10,MyTh \r\n TextColor=Red; CustomerId=33801"); //同时设置多个单元格、多种属性
   */
  public setCellPropStr(commandStr: any, sheetHandle: string = "") {
    ffunc(this.suReport, sheetHandle + 'SetCellProp', commandStr);
  }

  /**
   * 设置自定义属性
   * @param row
   * @param col
   */
  public SetCellProp(row, col, key, value) {
    if (col == null || (col == '' && typeof(col) != 'number')) {
      ffunc(this.suReport, 'SetCellProp', `${row} \r\n ${key} \r\n ${value}`);
    } else {
      ffunc(this.suReport, 'SetCellProp', `${row} \r\n ${col} \r\n ${key} \r\n ${value}`);
    }

  }
  /**
   * 设置自定义属性
   * @param row
   * @param col
   */
  public SetCustomCellProp(str: string, strHandle = '') {
    ffunc(this.suReport, strHandle + 'SetCellProp', `${str}`);
  }
  /**
   * 设置字体属性
   * @param row
   * @param col
   * @param fontName 字体名称，例如"Arial" 、 "微软雅黑";
   * @param size 转换后的大小，肯定是正数
   * @param bold 否加粗, 1或0
   * @param strHandle
   */
  public setCellFont(row: number, col: number, str: string, strHandle = '') {
    ffunc(this.suReport, strHandle + 'setCellFont', `${row} \r\n ${col} \r\n ${str}`);
  }

  /**
   * 导入报表，弹出选择框
   */
  public importReport() {
    ffunc(this.suReport, 'callfunc', "103");
  }
  /**
   * 导出xml
   * @param WorkSheets 导出指定页，不指定导出全部，或者全部all，默认是全部
   * @param isReturnContent 如果为true, 表示函数返回的不是文件名，而是内容本身的XML串, 默认是false. 如果 isReturnContent = true, 那么 Filename 就不需要指定了，也不会弹出文件选择对话框, 因为不输出到文件了;

   */
  public exportReport(WorkSheets: string = '', isReturnContent = false) {
    if (!this.isNull(WorkSheets)) {
      return ffunc(this.suReport, 'callfunc', `1074\r\n WorkSheet=${WorkSheets};isReturnContent=${isReturnContent}`);
    } else {
      return ffunc(this.suReport, 'callfunc', `1074\r\n isReturnContent=${isReturnContent}`);
    }
  }
  /**
   * 打开文件或目录选择对话框
   */
  public fileDialog() {
    return ffunc(this.suReport, 'FileDialog', 'isDir=true');
  }

  /**
   * 导出指定类型文件至指定位置
   */
  public exportForType(type, filename) {
    return ffunc(this.suReport, 'callfunc', `105 \r\n Type=${type};gridLine=true;includeFormula=false;filename=${filename}`);
  }

  /**
   * 将报表导出到excel
   */
  public exportReportToExcel() {
    ffunc(this.suReport, 'callfunc', `105`);
  }

  /**
   * 将报表导出到PDF
   */
  public exportReportToPDF(filename) {
    ffunc(this.suReport, 'callfunc', `105 \r\n Type=pdf;gridLine=true;includeFormula=false;filename=${filename}`);
  }

  /**
   * 打印预览
   * @param all true=全部；false=当前页
   */
  public printView(all: boolean = true) {
    ffunc(this.suReport, "callfunc", `18\r\n all=${all}`);
  }

  /**
   * 打印报表
   * @param WorkSheet 工作表， 可以是如下几种：
   ** OpenDialog（弹出对话框选择打印(如果多个工作表)）;
   ** All - 打印全部工作表
   ** Default - 打印在 “属性” 对话框中勾选了 “默认打印本工作表” 的所有工作表;
   ** Current - 打印当前工作表;
   ** 以逗号分隔的工作表名或工作表顺序号 - 打印指定的工作表;
   */
  public print(WorkSheet = 'all') {
    ffunc(this.suReport, 'Print', `isOpenSysDialog=false; WorkSheet=${WorkSheet}`)
  }

  /**
   * 打印所有
   */
  public printAll() {
    ffunc(this.suReport, 'Print', 'WorkSheet=All')
  }

  /**
   * 打印当前页
   */
  public printCurrent() {
    ffunc(this.suReport, 'Print', 'WorkSheet=Current')
  }

  /**
   * 设置纸张打印方向
   * @param isPortrait 是否为纵表(true=纵表；false=横表)
   */
  public setPrintOriantation(isPortrait: boolean, sheetHandle: string = "") {
    ffunc(this.suReport, sheetHandle + 'SetPrintProp', `Oriantation=${isPortrait ? "Portrait" : "Landscape"}`);
  }

  /**
    * 设置打印纸张尺寸
    * @param paperNumber 纸张编号 默认9（A4）
    */
  public setPrintSize(paperNumber = 9) {
    for (let sheetIndex = 0; sheetIndex < this.getWorksheets(); sheetIndex++) {
      const sheetHandle = this.getHandle(sheetIndex);
      ffunc(this.suReport, sheetHandle + 'SetPrintProp', `paperNumber=${paperNumber}`);
    }
  }

  /**
   * 设置打印时纸的边距(单位为毫米)
   * @param left
   * @param top
   * @param right
   * @param bottom
   */
  public setPrintMargin(left: number, top: number, right: number, bottom: number, sheetHandle: string = "") {
    ffunc(this.suReport, sheetHandle + 'SetPrintProp', `Margin=${left},${top},${right},${bottom}`);
  }

  /**
   * 获取打印属性
   * @param propertyName 打印属性
   ** Printer 打印机名
   ** PaperNumber 打印纸号
   ** Oriantation 纸的方向
   ** Scale 打印的缩放比例
   ** AutoScale 自动缩放, 空串(或false)/NoEnlarge/AutoFit 分别表示不自动缩放/自动缩小但不放大/自动缩放使打印纸满幅显示
   ** Copies 打印份数, 大于0的纯数字
   ** Margin 纸的边距, 逗号分隔的左上右下, 单位为毫米
   ** Duplex 支持双面打印的打印机, 双面打印模式
   ** isPrintBothSide 打印奇偶页时是否交换左右边距
   ** PrintColor 彩色打印方式, Device/BW 分别表示采用打印设备所具备的色彩能力打印/强制黑白打印
   * @param sheetHandle
   */
  public getPrintProp(propertyName: string, sheetHandle: string = "") {
    return ffunc(this.suReport, sheetHandle + 'GetPrintProp', propertyName);
  }

  /**
   * 根据行列号得到单元名
   * @param row
   * @param col
   */
  public getCellName(row, col) {
    return ffunc(this.suReport, 'GetCellName', `${row} \r\n ${col}`);
  }

  /**
   * 根据单元名得到行号
   * @param cellName 单元名, 或单元格范围
   ** 行号, 如果参数是单元格范围, 则返回逗号分隔的行号
   ** AF.func("GetCellRow", "A5"); 返回 "4"
   ** AF.func("GetCellRow", "A5:D6"); 返回 "4,5"
   */
  public getCellRow(cellName: string, sheethandle: string = ""): string {
    return ffunc(this.suReport, sheethandle + 'GetCellRow', cellName);
  }

  /**
   * 根据单元名得到列号
   * @param cellName 单元名, 或单元格范围
   ** 列号, 如果参数是单元格范围, 则返回逗号分隔的列号
   ** AF.func("GetCellCol", "A5"); 返回 "4"
   ** AF.func("GetCellCol", "A5:D6"); 返回 "4,5"
   */
  public getCellCol(cellName: string, sheethandle: string = ""): string {
    return ffunc(this.suReport, sheethandle + 'GetCellCol', cellName);
  }

  /**
   * 取得当前焦点单元格
   ** 返回 串，单元格名,如 "D4"、"E4"; 如果当前选中的是内嵌对象(如文本框)，则返回它的别名
   */
  public getCurrentCell(cellIndex = 0) {
    return ffunc(this.suReport, 'GetCurrentCell', '');
  }

  /**
   * 取得当前焦点单元格
   */
  public getCurrentCells(sheethandle: string = "") {
    return ffunc(this.suReport, sheethandle + 'GetCurrentCells', '');
  }

  /**
   * 取得某单元的内容，或者计算公式的值
   * @param commandStr 命令字符串
   ** var s1 = AF.func("getCellData", "3 \r\n 9");
   ** var s2 = AF.func("getCellData", "B7");
   ** var s4 = AF.func("getCellData", "MyTh"); //"MyTh"是别名
   ** var s5 = AF.func("getCellData", "D3:F8"); //一次性取多个单元格的内容
   */
  public getCellData(commandStr: any) {
    return ffunc(this.suReport, 'GetCellData', commandStr);
  }

  /**
   * 获取单元格的值
   * @param row
   * @param col
   * @param sheetHandle
   */
  public getCellValue(row: number, col: number, sheetHandle: string = "") {
    return ffunc(this.suReport, sheetHandle + "GetCellData", `${row} \r\n ${col}`);
  }

  /**
   * 获取单元格的值 
   * @param colName
   * @param sheetHandle
   */
  public getCellValueByCol(colName: string, sheetHandle: string = "") {
    return ffunc(this.suReport, sheetHandle + "GetCellData", `${colName}`);
  }

  /**
   * 设置选中单元格的值
   * @param value
   */
  public setSelectedCellsValue(value: string) {
    let cells = this.getCurrentCells();
    if (!this.isNull(cells)) {
      let arr = cells.split(',');
      for (let index = 0; index < arr.length; index++) {
        const elArr = arr[index].split(':');
        const startRow = Number(this.getCellRow(elArr[0]));
        const startCol = Number(this.getCellCol(elArr[0]));
        const endRow = Number(this.getCellRow(elArr[1]));
        const endCol = Number(this.getCellCol(elArr[1]));
        for (let rIndex = startRow; rIndex <= endRow; rIndex++) {
          for (let cIndex = startCol; cIndex <= endCol; cIndex++) {
            this.setCellData(`${rIndex} \r\n ${cIndex} \r\n${value}`);
          }
        }
      }
    }
  }

  /**
   * 设置某单元的内容、或计算公式(计算公式以等号开头)
   * @param commandStr 命令字符串
   ** AF.func("SetCellData", "3 \r\n 9 \r\n年度计划");
   ** AF.func("setCellData", "B7\r\n=B8+B9");    //为B7单元格设置公式
   ** AF.func("setCellData", "MyTh \r\n年度计划");    //"MyTh"是别名
   ** AF.func("setCellData", "A1,B3:B10, C3:C11, E11, MyTh \r\n12"); //同时将多个单元格内容全部设置为"12"
   */
  public setCellData(commandStr: any, sheetHandle: string = "") {
    ffunc(this.suReport, sheetHandle + 'SetCellData', commandStr);
  }

  /**
   * 给指定单元格赋值
   * @param row
   * @param col
   * @param val
   */
  public setCellValue(row, col, val, sheetHandle: string = "") {
    //参数2和参数3之间不得留有多余空格
    if (col == null || (col == '' && typeof(col) != 'number')) {
      this.setCellValueByAlias(row, val, sheetHandle);
    } else {
      ffunc(this.suReport, sheetHandle + 'SetCellData', `${row} \r\n ${col} \r\n${val}`);
    }
  }

  /**
   * 根据别名给单元格赋值
   * @param alias
   * @param val
   */
  public setCellValueByAlias(alias: string, val: any, strHandle = '') {
    ffunc(this.suReport, strHandle + 'SetCellData', `${alias} \r\n${val}`);
  }

  /**
   * 设置可编辑权限单元格名(有多个则以逗号分隔)，如"A5, B4, D4";
   * @param cell
   * @param sheethandle
   */
  public setCellCanEdit(cell: string, sheethandle: string = "") {
    var commandStr = `level=top;cell=${cell}`;
    this.addEditAbleOnly(commandStr, sheethandle);
  }
  /**
   * 设置可编辑权限单元格名（区域）;
   * @param cell
   * @param sheethandle
   */
  public setCellAreaCanEdit(cellArea: string, sheethandle: string = "") {
    var commandStr = `level=top;cellArea=${cellArea}`;
    this.addEditAbleOnly(commandStr, sheethandle);
  }

  /**
   * 根据表达式查找单元格
   * @param attributeName
   * @param attributeVale
   * @param sheetHandle
   */
  public findCell(attributeName, attributeVale, sheetHandle: string = "") {
    return ffunc(this.suReport, sheetHandle + 'FindCell', `${attributeName}='${attributeVale}'`);
  }

  /**
   * 根据表达式查找单元格(不等于!=)
   * @param attributeName
   * @param attributeVale
   * @param sheetHandle
   */
  public findCell1(attributeName, attributeVale, sheetHandle: string = "") {
    return ffunc(this.suReport, sheetHandle + 'FindCell', `${attributeName}!='${attributeVale}'`);
  }

  /**
   * 查询单元格
   * @param searchText 查询文本
   */
  public findCell2(searchText: string): RowAndCol[] {
    const rowAndCols: RowAndCol[] = [];
    const strRowCols: string = ffunc(this.suReport, 'FindCell', searchText);
    const strRowColArray: string[] = strRowCols.split(',');

    for (const rowCol of strRowColArray) {
      const rowAndCol = this.convertRowAndCol(rowCol);
      rowAndCols.push(rowAndCol);
    }

    return rowAndCols;
  }

  public convertRowAndCol(strRowCol: string): RowAndCol {
    const row = Number(strRowCol.replace(/[^0-9]/ig, ``)) - 1;
    const colA = strRowCol.replace(`${row + 1}`, '');

    return {
      col: this.toExcelIndex(colA),
      row: row
    };
  }

  /**
   * 取得某单元的显示内容命令字符串
   * @param commandStr 命令字符串
   ** var s1 = AF.func("getCellText", "3 \r\n 9");
   ** var s2 = AF.func("getCellText", "B7");
   ** var s4 = AF.func("getCellText", "MyTh"); //"MyTh"是别名
   ** var s5 = AF.func("getCellText", "A1:A9"); //一次性取多个单元格的内容
   */
  public getCellText(commandStr: any) {
    return ffunc(this.suReport, 'GetCellText', commandStr);
  }

  /**
   * 取得工作表的名称
   * @param sheetIndex
   */
  public getWorksheetName(sheetIndex = 0) {
    return ffunc(this.suReport, 'GetWorksheetName', `${sheetIndex}`);
  }

  /**
   * 修改工作表的名称
   * @param commandStr 命令字符串
   ** 序号(从0开始计数)，或工作表名称
   ** 新的名称
   ** AF.func("SetWorksheetName", "1\r\n 新名字");
   ** AF.func("SetWorksheetName", "旧名字\r\n 新名字");
   */
  public setWorksheetName(commandStr: any) {
    return ffunc(this.suReport, 'SetWorksheetName', commandStr);
  }

  /**
   * 修改工作表的名称
   * @param sheetIndex 修改哪个工作表（索引从0开始）
   * @param sheetName 新名称
   */
  public setSheetName(sheetIndex: number, sheetName: string) {
    ffunc(this.suReport, 'SetWorksheetName', sheetIndex + " \r\n " + sheetName);
  }

  /**
   *  设置当前工作表的名称
   * @param sheetName 新名称
   */
  public setCurrentSheetName(sheetName: string) {
    const sheetIndex = ffunc(this.suReport, 'GetCurrentWorksheet', '');
    ffunc(this.suReport, 'SetWorksheetName', sheetIndex + " \r\n " + sheetName);
  }

  /**
   * 设置工作表显示
   * @param sheetNames 工作表名, 如果要一次性恢复多个工作表, 请以逗号分隔各个工作表名; 空串表示恢复全部工作表
   */
  public setSheetShow(sheetNames: string = "") {
    //显示
    ffunc(this.suReport, 'UnhideWorkSheet', sheetNames + " \r\n locate=current");
  }

  /**
   * 设置工作表隐藏
   * @param commandStr  命令字符串
   * 可选, 无参数表示隐藏当前工作表, 如果有参数, 那么格式为 sheetName=[?];sheetNum=[?], 含义如下:
   * sheetName - 工作表名, 如果要一次性隐藏多个工作表, 工作表名之间以逗号分隔
   * sheetNum - 工作表序号(从0开始计数), 如果要一次性隐藏多个工作表, 序号之间以逗号分隔
   */
  public setSheetHide(commandStr) {
    ffunc(this.suReport, 'HideWorkSheet', commandStr);
  }

  /**
   * 取得所有隐藏的工作表的表名
   */
  public getHideWorkSheet() {
    return ffunc(this.suReport, 'GetHideWorkSheet');
  }

  /**
   * 删除工作表
   * @param commandStr 命令字符串
   ** 序号(从0开始计数)，或工作表名称
   ** AF.func("DeleteWorksheet", "1");
   ** AF.func("DeleteWorksheet", "表名字");
   */
  public deleteWorksheet(commandStr: string) {
    return ffunc(this.suReport, 'DeleteWorksheet', commandStr);
  }

  /**
   * 改变当前工作表的位置
   * @param sheetIndex 旧索引
   * @param newSheetIndex 新索引
   */
  public exchangeWorksheet(sheetIndex: number, newSheetIndex: number) {
    ffunc(this.suReport, "ExchangeWorksheet", `${newSheetIndex} \r\n ${sheetIndex}`);
  }

  /**
   * 追加工作表(追加到末尾，追加之后新的sheet页会变成活动页)
   * @param commandStr 如果不指定 sheetNum 和 sheetName, 也不打开对话框, 那么将导入全部工作表.
   * AF.func("appendWorksheet", xmlFile + "\r\n" + " isWithFormula=true;isWithDS=true;SheetNum=1,2,3");
   * @returns 1/0 - 成功/失败
   */
  public appendWorksheet(commandStr: any): string {
    return ffunc(this.suReport, "appendWorksheet", commandStr);
  }

  /**
   * 添加工作表：从外部报表导入
   * @param reportXml 报表的URL或大串
   * @param sheetNum 逗号分隔的工作表序号, 例如 "0,3,5" 表示导入顺序号为0、3、4的工作表;
   * @returns 1/0 - 成功/失败
   */
  public appendWorksheetByIndex(reportXml, sheetNum): string {
    return ffunc(this.suReport, "appendWorksheet", reportXml + "\r\n" + " sheetNum=" + sheetNum);
  }

  /**
   * 添加工作表：从外部报表导入
   * @param reportXml 报表的URL或大串
   * @param sheetName 逗号分隔的工作表名, 例如 "利润表, 资产负债表";
   * @returns 1/0 - 成功/失败
   */
  public appendWorksheetByName(reportXml, sheetName): string {
    return ffunc(this.suReport, "appendWorksheet", reportXml + "\r\n" + " sheetName=" + sheetName);
  }

  /**
   * 设置sheet页自定义属性
   * @param commandStr 命令字符串
   ** AF.func("SetMemo", "0 \r\n sheettag \r\n33333333333333")
   */
  public setSheetProp(commandStr: any) {
    ffunc(this.suReport, 'SetMemo', commandStr);
  }

  /**
   * 设置sheet页自定义属性
   * @param commandStr 命令字符串
   ** AF.func("GetMemo", "0 \r\n sheettag")
   */
  public getSheetProp(commandStr: any) {
    ffunc(this.suReport, 'GetMemo', commandStr);
  }

  /**
   * 设置某自由存储区的存储串
   * @param sheetIndex
   * @param key 存储区的ID，为任意串，但不得含逗号
   * @param value
   */
  public setMemo(sheetIndex, key, value) {
    //不要在参数2和参数3之间留有多余空格，否则空格也会保存到XML中去的
    ffunc(this.suReport, 'SetMemo', `${sheetIndex} \r\n ${key}\r\n${value}`);
  }

  /**
   * 取得某自由存储区的存储串
   * @param sheetIndex
   * @param key
   */
  public getMemo(sheetIndex, key) {
    return ffunc(this.suReport, 'GetMemo', `${sheetIndex} \r\n ${key}`);
  }

  /**
   * 取得自由存储区的所有ID
   * @param sheetIndex 工作表顺序号(从0开始计数)，如果为空串，则表示是和工作表无关的的独立存储区
   * @returns 逗号分隔的存储区ID号
   */
  public getMemos(sheetIndex) {
    return ffunc(this.suReport, 'GetMemos', `${sheetIndex}`);
  }

  /**
   * 限制某些交互功能,默认只读
   * @param commandStr 命令字符串
   ** 可包含如下、以逗号分隔的串:
   **　1 －公式修改权
   **　2 －非公式的修改权
   **　3 －内容复制权
   **　4 －格式修改权(如行高列宽、字体、对齐、隐藏等)，也可分拆成:
   **　　　4a － 行高列宽调整权
   **　　　4b － 行列隐藏权
   **　　　4c － 行列取消隐藏权
   **　　　4d － 除行高列宽、行列隐藏、取消隐藏外的其它格式调整权
   **　8 －行列增删权, 也可拆分成：
   **　　　256 －行增删权
   **　　　512 －列增删权
   **　16－被保护的单元的内容修改权
   **　32－平衡校验修改权
   **　64－数据源修改权，也可拆分成：
   **　　　64a －新建数据源权
   **　　　64d －删除数据源权
   **　　　64m －修改数据源权
   **　128－工作表的增删权
   **　0 －不显示单元格的焦点(通常和 1、2一起使用)
   */
  public swkrntpomzqa(commandStr: any = '1,2') {
    ffunc(this.suReport, 'Swkrntpomzqa', commandStr);
  }

  /**
   * 添加可编辑的单元格范围，除了这些单元格，其它单元格都不得修改
   * @param commandStr 命令字符串
   ** AF.func("addEditAbleOnly", "cellArea=B3:B5, D3:D5; alias=KK*"); //仅如下范围的单元格可以编辑: B3:B5之间的单元格、 D3:D5之间的单元格、或别名以"KK"开头的单元格
   */
  public addEditAbleOnly(commandStr: any, sheetHandle: string = "") {
    ffunc(this.suReport, sheetHandle + 'addEditAbleOnly', commandStr);
  }

  /**
   * 添加不可编辑的单元格范围，除了这些单元格不可修改，其它单元格都是可以修改的
   * @param commandStr 命令字符串
   ** AF.func("addUnEditAbleOnly", "cellArea=B3:B5, D3:D5; alias=KK*");
   */
  public addUnEditAbleOnly(commandStr: any) {
    ffunc(this.suReport, 'addUnEditAbleOnly', commandStr);
  }

  /**
   * 清理上面2个函数 (addEditAbleOnly, addUnEditAbleOnly) 设置的权限
   ** 1.不影响 Swkrntpomzqa 函数设置的权限;
   ** 2.只对当前工作表生效
   */
  public clearLimit() {
    ffunc(this.suReport, 'ClearLimit', '');
  }

  /**
   * 判断某单元是否有编辑权限
   * @param commandStr 命令字符串
   ** var isAble = AF.func("getCellEditAble", "3 \r\n 9");
   ** var isAble = AF.func("getCellEditAble", "B7");
   ** var isAble = AF.func("getCellEditAble", "MyTh"); //"MyTh"是别名
   */
  public getCellEditAble(commandStr: any) {
    ffunc(this.suReport, 'GetCellEditAble', commandStr);
  }

  /**
   * 预订事件
   * @param commandStr 命令字符串
   ** 需要预订的事件有：CurSelChanged、Clicked、DblClicked、EditChanged、Editing、CellPropChanged，其含义分别是：当前单元格切换、鼠标点击单元格、鼠标双击单元格、单元格或文本框的内容输入已更新、单元格或文本框的输入框已打开并且内容有修改、工具箱中单元格的某些属性被修改
   ** AF.func("SubscribeEvent", "CurSelChanged, Clicked");
   */
  public subscribeEvent(commandStr: any) {
    ffunc(this.suReport, 'SubscribeEvent', commandStr);
  }

  /**
   * 获取单元格的tag属性
   * @param sheetIndex
   * @param row
   * @param col
   */
  // public getCellTag(row: number, col: number, sheetHandle: string = ""): TagModel {
  //   var cellTag = ffunc(this.suReport, sheetHandle + "GetCellProp", `${row} \r\n ${col} \r\n tag`);
  //   return cellTag == "" ? null : JSON.parse(cellTag);
  // }

  /**
   * 设置单元格的tag属性
   * @param sheetIndex
   * @param row
   * @param col
   * @param value
   */
  public setCellTag(row, col, value: string, sheetHandle: string = "") {
    if (col == null || (col == '' && typeof(col) != 'number')) {
      ffunc(this.suReport, sheetHandle + "SetCellProp", `${row} \r\n tag \r\n ${value}`);
    } else {
      ffunc(this.suReport, sheetHandle + "SetCellProp", `${row} \r\n ${col} \r\n tag \r\n ${value}`);
    }
  }

  /**
   * 获取sheet的sheettag属性
   * @param sheetIndex
   */
  // public GetSheetTag(sheetIndex: number): SheetTag {
  //   var handle = ffunc(this.suReport, "GetHandle", sheetIndex.toString());//取得第index个工作表的句柄
  //   var sheettag = ffunc(this.suReport, handle + "GetCellProp", `0 \r\n 0 \r\n sheettag`);//获取自定义的tag属性
  //   return sheettag == "" ? null : JSON.parse(sheettag);
  // }

  /**
   * 设置sheet的sheettag属性
   * @param sheetIndex
   * @param value
   */
  public SetSheetTag(sheetIndex: number, value: string) {
    var handle = ffunc(this.suReport, "GetHandle", sheetIndex.toString());//取得第index个工作表的句柄
    ffunc(this.suReport, handle + "SetCellProp", `0 \r\n 0 \r\n sheettag \r\n ${value}`);//设置自定义的tag属性
  }

  /**
   * 获取当前sheet页tag值
   */
  // public getCurrentSheetTag(): SheetTag {
  //   const sheettag = this.getCellProp(0, 0, 'sheettag');
  //   return sheettag == "" ? null : JSON.parse(sheettag);
  // }

  /**
   * 设置当前sheet页tag值
   */
  public setCurrentSheetTag(value: string) {
    const sheettag = this.SetCellProp(0, 0, 'sheettag', value);
  }

  /**
   * 取得第index个工作表的句柄
   * @param sheetIndex
   */
  public getHandle(sheetIndex) {
    return ffunc(this.suReport, "getHandle", sheetIndex.toString());
  }

  /**
   * 获取所有工作表下所有单元格设置tag属性
   */
  // public getAllCellTagData(): Array<TagModel> {
  //   var result: Array<TagModel> = [];
  //   let sheetLen = this.getWorksheets();
  //   for (let sheetIndex = 0; sheetIndex < sheetLen; sheetIndex++) {
  //     var handle = this.getHandle(sheetIndex);//取得第index个工作表的句柄
  //     var rowLen = this.getRows(handle);
  //     var colLen = this.getCols(handle);
  //     for (let rIndex = 0; rIndex < rowLen; rIndex++) {
  //       for (let cIndex = 0; cIndex < colLen; cIndex++) {
  //         var tag = this.getCellTag(rIndex, cIndex, handle);
  //         if (tag != null) {
  //           tag.row = rIndex;
  //           tag.col = cIndex;
  //           tag.sheetindex = sheetIndex;
  //           result.push(tag);
  //         }
  //       }
  //     }
  //   }
  //   return result;
  // }

  /**
   *清除tag值
   */
  // public clearSelectedAreaTag() {
  //   const cellsStr: string = this.getCurrentCells();
  //   if (!isNull(cellsStr)) {
  //     const rowsStr: string = this.getCellRow(cellsStr);
  //     const colsStr: string = this.getCellCol(cellsStr);
  //     const rows = rowsStr.split(',');
  //     const cols = colsStr.split(',');
  //     for (let r = Number(rows[0]); r <= Number(rows[1]); r++) {
  //       for (let c = Number(cols[0]); c <= Number(cols[1]); c++) {
  //         var tag = this.getCellTag(r, c);
  //         if (tag != null) {
  //           this.setCellTag(r, c, "");
  //         }
  //         if (this.getCellValue(r, c) == "已绑定") {
  //           this.setCellValue(r, c, "");
  //         }
  //       }
  //     }
  //   }
  // }

  /**
   * 获取tag值
   * @param row
   * @param col
   */
  // public getTag(row, col): TagModel {
  //   const tag = this.getCellProp(row, col, 'tag');
  //   return isNull(tag) ? null : JSON.parse(tag);
  // }

  /**
   * 创建空白页
   * @param name
   */
  public addWorksheet(name: string) {
    ffunc(this.suReport, "addWorksheet", `name=${name}`);
  }

  public disableMenu() {
    ffunc(this.suReport, "DisableMenu", `'copy' \r\n false \r\n false`);
  }



  /**
   * 导入Excel文件
   * @param file
   */
  public importExcelFile(file) {
    this.appendWorksheet(file);
  }

  /**
   * 取得上次打开(Build)的报表的文件名, 包括URL
   */
  public getFileURL() {
    return ffunc(this.suReport, "GetFileURL", '');
  }

  //#region  自适应纸张大小
  /**
   * 自适应纸张大小
   * @param size 默认A4；也可以210*297单位(mm)
   */
  autoFitPaperSize(size: string = "A4") {
    //A4=210*297
    if (size.toLowerCase() == "a4") {
      this.setAllSheetA4Size();
    }
    else {
      //100*100
    }
  }

  /**
   * （开发中）设置所有sheet页的打印纸尺寸
   * @param size 例：210*297（单位：mm）
   * @param margin 边距（单位：mm）
   */
  public setAllSheetPrintSize(size: string, margin: margin) {
    size = size.replace(/\s+/g, "");
    let isA4: boolean = size == "210*297";
    let aWidth = Number(size.split('*')[0]);
    let aHeight = Number(size.split('*')[1]);

    let pxWidth = this.getPxWidth(aWidth);
    let pxHeight = this.getPxHeight(aHeight);

    let sheetCount = this.getWorksheets();
    for (let i = 0; i < sheetCount; i++) {
      var sheetHandle = this.getHandle(i);
      if (isA4) {
        //获取纸张方向
        const oriantation = this.getPrintOriantation(sheetHandle);
        //设置A4格式
        this.setSheetA4Size(sheetHandle, oriantation == "portrait");
      }
      else {
        this.setSheetPrintSize(sheetHandle, pxWidth, pxHeight, margin);
      }
    }
  }

  /**
   * （开发中）设置sheet页的打印纸尺寸
   * @param sheetHandle
   * @param pxWidth 纸张宽度（单位：px）
   * @param pxHeight 纸张高度（单位：p）
   * @param margin 边距（单位：mm）
   */
  private setSheetPrintSize(sheetHandle: string, pxWidth: number, pxHeight: number, margin: margin) {

  }

  /**
   * 自适应A4
   * @param sheetIndexs 不指定则设置所有，指定时用逗号隔开
   */
  public setAllSheetA4Size(sheetIndexs: string = "", minPx: number = 1.5, maxPx = 2.5) {
    //关闭屏幕重画
    this.SetRedrawAble(false);
    if (sheetIndexs == "") {
      let sheetCount = this.getWorksheets();
      for (let i = 0; i < sheetCount; i++) {
        var sheetHandle = this.getHandle(i);
        //获取纸张方向
        const oriantation = this.getPrintOriantation(sheetHandle);
        //设置A4格式
        this.setSheetA4Size(sheetHandle, oriantation == "portrait", minPx, maxPx);
      }
    }
    else {
      sheetIndexs.split(',').forEach((el) => {
        var sheetHandle = this.getHandle(el);
        //获取纸张方向
        const oriantation = this.getPrintOriantation(sheetHandle);
        //设置A4格式
        this.setSheetA4Size(sheetHandle, oriantation == "portrait", minPx, maxPx);
      })
    }
    //开启屏幕重画
    this.SetRedrawAble(true);
  }

  /**
   * 自适应A4
   * 纵表：Left 2.5cm Right 1.5cm Top 1.5cm Bottom 1.5cm
   * 横表：Left 1.5cm Right 1.5cm Top 2.5cm Bottom 1.5cm
   * Tip1: 最后一行为签字行，行高固定为35
   * @param sheetHandle sheet页索引
   * @param isPortrait 是否为纵表(true=纵表；false=横表)
   */
  public setSheetA4Size(sheetHandle: string, isPortrait: boolean, minPx: number = 1.5, maxPx = 2.5) {
    let a4Width = this.getA4PxWidth();
    let a4Height = this.getA4PxHeight();
    const top = this.cmToPx(isPortrait ? minPx : maxPx, false);
    const bottom = this.cmToPx(minPx, false);
    const left = this.cmToPx(isPortrait ? maxPx : minPx, true);
    const right = this.cmToPx(minPx, true);
    if (!isPortrait) {
      const ac = a4Height;
      a4Height = a4Width;
      a4Width = ac;
    }
    console.log(`A4=>宽${a4Width}`);
    a4Width = a4Width - left - right;
    a4Height = a4Height - top - bottom;
    // const sheetHandle = this.getHandle(sheetIndex);
    const sheetWidth = this.getSheetWidth(sheetHandle);
    console.log(`A4=>宽${a4Width},左=>${left},右=>${right} 实际=>宽${sheetWidth}`);
    const sheetHeight = this.getSheetHeight(sheetHandle);
    const countRow = this.getRows(sheetHandle);
    const countCol = this.getCols(sheetHandle);

    // //设置签章图片的大小
    // 目前有问题
    // var pictures = sheet.pictures.all();
    // var signImageNameArr: Array<string> = ["NvJC", "NvJL", "NVFH", "NvSH", "NvPZ"];
    // for (let index = 0; index < pictures.length; index++) {
    //   let element = pictures[index];
    //   if (signImageNameArr.indexOf(element.name.toString()) >= 0) {
    //     element.height(this.signImageHeight);
    //   }
    // }
    //行高
    const dh = (a4Height - sheetHeight - this.lastRowHeight - 5) / (countRow - 2);
    for (let i = 0; i < countRow - 1; i++) {
      let height = this.getRowHeight(i, sheetHandle);
      this.setRowHeight(i, height + dh, sheetHandle);
    }

    //设置随后一行行高
    this.setRowHeight(countRow - 2, this.lastRowHeight, sheetHandle);
    const pyl = this.GetRowOffset(countRow, sheetHandle);
    let h2 = a4Height - pyl;
    const h = this.getRowHeight(countRow - 3, sheetHandle);
    this.setRowHeight(countRow - 3, h2 + h, sheetHandle);
    // 列宽
    const dw = (a4Width - sheetWidth) / (countCol - 1);
    for (let i = 0; i < (countCol - 1); i++) {
      let width = this.getColWidth(i, sheetHandle);
      this.setColWidth(i, width + dw, sheetHandle);
    }
    const pyl2 = this.GetColOffset((countCol - 1), sheetHandle);
    let w2 = a4Width - pyl2;
    const w = this.getColWidth((countCol - 1), sheetHandle);
    this.setColWidth((countCol - 1), w2 + w, sheetHandle);
    //设置纸张方向
    this.setPrintOriantation(isPortrait, sheetHandle);
    const minPx10 = minPx * 10;
    const maxPx10 = maxPx * 10;
    //设置纸张边距
    if (isPortrait) {
      //纵表：Left 2.5cm Right 1.5cm Top 1.5cm Bottom 1.5cm

      this.setPrintMargin(maxPx10, minPx10, minPx10, minPx10, sheetHandle);
    }
    else {
      //横表：Left 1.5cm Right 1.5cm Top 2.5cm Bottom 1.5cm
      this.setPrintMargin(minPx10, maxPx10, minPx10, minPx10, sheetHandle);
    }
  }

  /**
   * 获取打印纸的宽度（单位：像素）
   * 1英寸＝25.4毫米
   * @param width 宽度（单位：mm）
   * @returns 像素
   */
  public getPxWidth(width: number) {
    const dpi = this.getDPI();
    return (width / 25.4) * dpi[0];
  }

  /**
   * 获取打印纸的高度（单位：像素）
   * 1英寸＝25.4毫米
   * @param height 高度（单位：mm）
   * @returns 像素
   */
  public getPxHeight(height: number) {
    const dpi = this.getDPI();
    return (height / 25.4) * dpi[1];
  }

  /**
   * 获取A4纸的像素宽度
   * A4纸的尺寸是210mm×297mm
   * 1英寸＝25.4毫米
   * A4纸的尺寸的图像的像素是(210/25.4)*分辨率×(297/25.4)*分辨率
   */
  public getA4PxWidth() {
    const dpi = this.getDPI();
    return (210 / 25.4) * dpi[0];
  }

  /**
   * 获取A4纸的像素高度
   * A4纸的尺寸是210mm×297mm
   * 1英寸＝25.4毫米
   * A4纸的尺寸的图像的像素是(210/25.4)*分辨率×(297/25.4)*分辨率
   */
  public getA4PxHeight() {
    const dpi = this.getDPI();
    return (297 / 25.4) * dpi[1];
  }

  /**
   *
   * @param cm
   * @param isWDPI true:宽度；false:高度
   */
  private cmToPx(cm: number, isWDPI: boolean) {
    const dpis = this.getDPI();
    const dpi = isWDPI ? dpis[0] : dpis[1];
    return ((cm * 10) / 25.4) * dpi
  }

  /**
   *  斜向一英寸里的物理像素数量
   *  设备分辨率一栏表
   *  1、px（pixels）：物理像素，硬件像素，设备像素
   *  2、dp,dip（deveice independent pixels）：逻辑像素、设备无关像素、CSS像素
   *  3、pt（point）：1/72英寸
   *  4、dpr（devicePixelRatio）: 设备像素缩放比，即 1dp的长度相当于几个px的长度
   *  5、ppi,dpi：像素密度（像素每英寸），斜向一英寸里的物理像素数量
   *  6、em: 相对于父元素的font-size的相对单位。
   *  7、rem: 相对于根元素的font-size的相对单位。
   *  8、vw: 1% 布局视口宽度
   *  9、vh: 1% 布局视口高度
   *  10、分辨率：横向物理像素数 * 纵向物理像素数
   */
  public getDPI() {
    var arrDPI = new Array();
    if ((window.screen as any).deviceXDPI != undefined) {
      arrDPI[0] = (window.screen as any).deviceXDPI;
      arrDPI[1] = (window.screen as any).deviceYDPI;
    }
    else {
      var tmpNode = document.createElement("DIV");
      tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
      document.body.appendChild(tmpNode);
      arrDPI[0] = tmpNode.offsetWidth;
      arrDPI[1] = tmpNode.offsetHeight;
      tmpNode.parentNode!.removeChild(tmpNode);
    }
    return arrDPI;
  }

  /**
   * 取得某行的偏移量
   * @param rowIndex 行号(从0开始计数)
   * @param strHanle
   */
  public GetRowOffset(row: number, strHanle: string): number {
    return Number(ffunc(this.suReport, strHanle + 'GetRowOffset', `${row}`));
  }

  /**
   * 取得某列的偏移量
   * @param col 列号(从0开始计数)，或列名(如 A、K、AC)
   * @param strHanle
   */
  public GetColOffset(col: any, strHanle: string): number {
    return Number(ffunc(this.suReport, strHanle + 'GetColOffset', `${col}`));
  }

  /**
   * 获取纸张方向
   * @param sheetIndex
   * @return portrait/landscape 分别表示垂直/横向走纸;
   */
  public getPrintOriantation(sheetHandle: string) {
    var strOriantation: string = ffunc(this.suReport, sheetHandle + "GetPrintProp", "Oriantation");
    if (this.isNull(strOriantation)) {
      //没有设置纸张方向
      const sheetWidth = this.getSheetWidth(sheetHandle);
      alert(sheetWidth);
      return sheetWidth > 900 ? "landscape" : "portrait";
    }
    else {
      //返回值 Portrait/Landscape 分别表示垂直/横向走纸;
      return strOriantation.toLowerCase();
    }
  }

  /**
  * 获取sheet的宽度
  */
  public getSheetWidth(sheetHandle: string = "") {
    // let total = 0;
    let len = this.getCols(sheetHandle);
    // for (let i = 0; i < len; i++) {
    //   total += this.getColWidth(i, sheetHandle);
    // }
    const total = this.GetColOffset(len - 1, sheetHandle);
    return total;
  }

  /**
   * 获取sheet的高度
   */
  public getSheetHeight(sheetHandle: string = "") {
    let total = 0;
    let len = this.getRows(sheetHandle);
    // for (let i = 0; i < len; i++) {
    //   total += this.getRowHeight(i, sheetHandle);
    // }
    total = this.GetRowOffset(len - 2, sheetHandle);
    return total;
  }
  //#endregion

  /**
   * 动态更改工具条中某按钮/菜单项的状态
   * @param functionIndex 功能号
   * @param functionName 可用状态，为 Enable、Visible、Check
   * @param status true / false
   */
  public setToolbarItemStatus(functionIndex: number, functionName: string, status: boolean) {
    return ffunc(this.suReport, 'SetToolbarItemStatus', `${functionIndex}\r\n ${functionName}\r\n ${status}`);
  }

  /**
   * 插入行
   * @param rowIndex 插入处行号 从0开始计数，-1表示从末尾添加
   * @param rowCount 可选, 插入行数，默认1
   * @param after 可选, true/false(或1/0、yes/no)，分别表示前插/后插，默认前插
   ** AF.func("insertRows", "1 \r\n 3 \r\n false"); //表示在第二行位置后插3行
   */
  public insertRows(rowIndex: number, rowCount: number = 1, after = 'no', strhandle: string = '') {
    ffunc(this.suReport, strhandle + 'insertRows', `${rowIndex}\r\n ${rowCount}\r\n ${after}`);
  }

  /**
   * 插入列
   * @param colIndex 插入处行号(从0开始计数，-1表示从末尾添加)，也有“基准行”的意思，新插入行的单元格属性(比如颜色、边界线等等)都是从该行复制过去的
   * @param colCount 可选, 插入行数，默认1
   * @param after 可选, true/false(或1/0、yes/no)，分别表示前插/后插，默认前插
   * @param strhandle 
   */
  public insertCols(colIndex: number, colCount: number = 1, after = 'no', strhandle: string = '') {
    ffunc(this.suReport, strhandle + 'insertCols', `${colIndex}\r\n ${colCount}\r\n ${after}`);
  }

  /**
   * 克隆某个区域到一个新的区域
   * @param staRowIndex 左上单元格行号(从0开始计数)
   * @param staColumnIndex 左上单元格列号(从0开始计数)，或列名(如 A、K、AC)
   * @param endRowIndex 右下单元格行号(从0开始计数)
   * @param endColumnIndex 右下列号(从0开始计数)，或列名(如 A、K、AC)
   * @param row 克隆到从该行开始的新区域 格式为 : row=[?];col=[?], row、col至少要定义一个 
   */
  public CloneArea(staRowIndex: number, staColumnIndex: number, endRowIndex: number, endColumnIndex: number, row = 0, sheetHandle: string = "") {
    ffunc(this.suReport, sheetHandle + 'CloneArea', `${staRowIndex}\r\n ${staColumnIndex}\r\n ${endRowIndex}\r\n ${endColumnIndex}\r\n row=${row}`);
  }

  /**
   * 取得所有显示掩码的id
   ** 掩码的id，相互以逗号分隔
   */
  public masks_Get() {
    return ffunc(this.suReport, "Masks_Get", '');
  }
  /**
   * 取得某个显示掩码的表达式
   * @param id
   */
  public mask_Get(id) {
    return ffunc(this.suReport, "Mask_Get", `${id}`);
  }
  /**
   * 添加一个显示掩码
   * @param dataType 可以是 string, int, double, date, datetime
   * @param codeStr 表达式
   ** 如果该掩码表达式已经存在，则返回原ID号
   ** var id = AF.func("Mask_Add", "string \r\n =formatNum(data, '￥#,##0.00')");
   ** var id = AF.func("Mask_Add", "string \r\n =picture()"); //添加图片显示掩码
   ** var id = AF.func("Mask_Add", "string \r\n =barcode(33,0,0,0)"); //添加二维码显示掩码
   */
  public mask_Add(dataType: string, codeStr: any,) {
    return ffunc(this.suReport, "Mask_Add", `${dataType} \r\n =${codeStr}`);
  }

  /**
   * 删除某个显示掩码
   * @param id
   */
  public mask_Delete(id) {
    return ffunc(this.suReport, "Mask_Delete", `${id}`);
  }
  /**
   * 按指定掩码表示数值
   * @param num 
   * @returns 
   */
  public formatNum(num: string) {
    return ffunc(this.suReport, "formatNum", `${num} \r\n #,##0.00`);
  }


  /**
   * 选取焦点单元、或嵌入对象(如文本框)
   * @param startRowIndex 行号(从0开始计数)
   * @param startColIndex 列号(从0开始计数)
   * @param endRowIndex 可选, 至行号, -1表示到末行
   * @param endColIndex 可选, 至列号, -1表示到末列
   * @result true/false - 成功/失败
   */
  public selectCell(startRowIndex, startColIndex, endRowIndex, endColIndex) {
    return ffunc(this.suReport, "SelectCell", `${startRowIndex} \r\n ${startColIndex} \r\n ${endRowIndex} \r\n ${endColIndex}`);
  }

  public selectCell1(row, col, para) {
    return ffunc(this.suReport, "SelectCell", `${row} \r\n ${col} \r\n ${para}`);
  }

  /**
   * 复制当前选中的行列
   * @result 1/0 - 成功/失败
   */
  public copyRows() {
    //20 复制  31 剪切
    return ffunc(this.suReport, 'callfunc', `20`);
  }

  /**
   * 粘贴复制的行列
   * @result 1/0 - 成功/失败
   */
  public pasteRows() {
    //34 粘贴格式和文字  35 仅粘贴文字
    return ffunc(this.suReport, 'callfunc', `34`);
  }
  public refsh() {
    ffunc(this.suReport, "SetRedrawAble", "true");
  }

  /**
   * 生成二维码
   * @param strhandle 句柄
   * @param aliasName 别名
   * @param codeStr 二维码内容
   */
  public createQRcode(strhandle, aliasName: string, codeStr: string) {
    // ffunc(this.suReport,strhandle + "DeleteGraphics", "MyQr");
    //插入别名为 "MyPic" 的文本框
    // ffunc(this.suReport,strhandle + "callfunc", "112 \r\n x=2; y=2; width=66; height=66; alias=MyQr");
    //将其数据类型改成字符串型
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n datatype \r\n 1`);
    //添加二维码显示掩码
    var id = ffunc(this.suReport, strhandle + "Mask_Add", "string \r\n =barcode(34,0,0,0)");
    //修改它的显示掩码， 至此，该文本框就二维码显示了
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n maskid \r\n ${id}`);

    //赋图片: 通过 SetCellData 赋值就行
    ffunc(this.suReport, strhandle + "SetCellData", `${aliasName} \r\n ${codeStr}`);
    //设置其它效果：背景透明，无边框
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n bgColor \r\n T`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n borderThick \r\n 0`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n align \r\n 1`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n vAlign \r\n 1`);
    //刷新一下屏幕
    ffunc(this.suReport, strhandle + "SetRedrawAble", "true");
  }

  /**
   * 设置单元格显示二维码
   * @param strhandle
   * @param row
   * @param col
   * @param codeStr
   */
  public setCellQRcode(strhandle, row, col, codeStr) {
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n datatype \r\n 1`);
    var id = ffunc(this.suReport, strhandle + "Mask_Add", "string \r\n =barcode(34,0,0,0)");
    //修改它的显示掩码， 至此，该文本框就二维码显示了
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n maskid \r\n ${id}`);
    ffunc(this.suReport, strhandle + "SetCellData", `${row} \r\n ${col} \r\n ${codeStr}`);
    //设置其它效果：背景透明，无边框
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n bgColor \r\n T`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n borderThick \r\n 0`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n align \r\n 1`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n vAlign \r\n 1`);
    //刷新一下屏幕
    ffunc(this.suReport, strhandle + "SetRedrawAble", "true");
  }

  /**
   * 单元格插入图片
   * @param strhandle
   * @param aliasName
   * @param base64Str
   */
  public insertPicture(strhandle, aliasName: string, base64Str: string) {
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n datatype \r\n 1`);
    var id = ffunc(this.suReport, strhandle + "Mask_Add", "string \r\n =picture()");
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n maskid \r\n ${id}`);
    //修改它的显示掩码， 至此，该文本框就二维码显示了
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n maskid \r\n ${id}`);

    //赋图片: 通过 SetCellData 赋值就行
    ffunc(this.suReport, strhandle + "SetCellData", `${aliasName} \r\n${base64Str}`);
    //设置其它效果：背景透明，无边框
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n bgColor \r\n T`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n imageArrange \r\n stretchKeepRatio`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n borderThick \r\n 0`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n align \r\n 1`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n vAlign \r\n 1`);
    //刷新一下屏幕
    ffunc(this.suReport, strhandle + "SetRedrawAble", "true");
  }
  /**
   * 单元格插入图片2
   * @param strhandle
   * @param aliasName
   * @param base64Str
   */
  public insertPicture2(row, col, base64Str: string, strhandle) {
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n datatype \r\n 1`);
    var id = ffunc(this.suReport, strhandle + "Mask_Add", "string \r\n =picture()");
    //修改它的显示掩码， 至此，该文本框就二维码显示了
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n maskid \r\n ${id}`);

    //赋图片: 通过 SetCellData 赋值就行
    ffunc(this.suReport, strhandle + "SetCellData", `${row} \r\n ${col} \r\n${base64Str}`);
    //设置其它效果：背景透明，无边框
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n bgColor \r\n T`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n imageArrange \r\n stretchKeepRatio`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n borderThick \r\n 0`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n align \r\n 1`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${row} \r\n ${col} \r\n vAlign \r\n 1`);
    //刷新一下屏幕
    ffunc(this.suReport, strhandle + "SetRedrawAble", "true");
  }
  /**
   * 单元格插入图片3
   * @param pic
   * @param isZoom
   */
  public insertPicToCell(pic, isZoom) {
    var currCell = ffunc(this.suReport, 'GetCurrentCell', '');
    //将其数据类型改成字符串型
    ffunc(this.suReport, "SetCellProp", currCell + " \r\n dataType \r\n string");
    //添加图片显示掩码
    var id = ffunc(this.suReport, "Mask_Add", "string \r\n =picture()");
    //修改它的显示掩码
    ffunc(this.suReport, "SetCellProp", currCell + "\r\n maskId \r\n" + id);

    ffunc(this.suReport, "SetCellData", currCell + "\r\n" + pic);
    ffunc(this.suReport, "SetCellProp", currCell + "\r\n bgColor \r\n T");
    ffunc(this.suReport, "SetCellProp", currCell + "\r\n borderThick \r\n 0");
    if (isZoom == true) {
      ffunc(this.suReport, "SetCellProp", currCell + "\r\n imageArrange \r\n stretchKeepRatio");
    }
    ffunc(this.suReport, "SetRedrawAble", "true");
  }

  public insertDate(strhandle: string, aliasName: string, date: string) {
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n datatype \r\n 4`);
    var id = this.mask_Add("date", "FormatDate(data,'YYYY-MM-DD')");
    //修改它的显示掩码， 至此，该文本框就二维码显示了
    ffunc(this.suReport, strhandle + "SetCellProp", `${aliasName} \r\n maskid \r\n ${id}`);
    //赋图片: 通过 SetCellData 赋值就行
    ffunc(this.suReport, strhandle + "SetCellData", `${aliasName} \r\n${date}`);
  }

  /**
   * 插入图片
   * @param imageUrl
   * @param tWidth
   * @param tHeight
   * @param x
   * @param y
   * @param sheetHandle
   */
  public insertImage(imageUrl: string, tWidth: string, tHeight: string, x: number, y: number, sheetHandle: string = '') {
    ffunc(this.suReport, sheetHandle + "callfunc", "192 \r\n x=" + x + "; y=" + y + ";IsSaveURLOnly=false;URL=" + imageUrl + ";maxSize=" + tWidth + "," + tHeight + ";");
  }

  /**
 * 插入图片
 * @param imageUrl
 * @param tWidth
 * @param tHeight
 * @param x
 * @param y
 * @param sheetHandle
 */
  public insertImage2(imageUrl: string, tWidth: string, tHeight: string, x: number, y: number, alias: string = '', sheetHandle: string = '') {
    ffunc(this.suReport, sheetHandle + "callfunc", "192 \r\n x=" + x + "; y=" + y + ";IsSaveURLOnly=false;URL=" + imageUrl + ";maxSize=" + tWidth + "," + tHeight + ";alias=" + alias + ";");
    // ffunc(this.suReport, sheetHandle + "SetCellProp", `${alias} \r\n isTransparent \r\n true`);
    // console.log("isTransparent", ffunc(this.suReport, sheetHandle + "GetCellProp", `${alias} \r\n`));
  }


  /**
   * 删除内嵌对象
   * @param alias 别名
   * @param strhandle
   */
  public deleteGraphics(alias, strHandle = '') {
    ffunc(this.suReport, strHandle + "DeleteGraphics", `${alias}`);
  }

  /**
   * 插入文本框
   * @param strhandle
   * @param alias 别名
   * @param mode 0：无边框
   */
  public insertInput(alias, mode = 1, strhandle: string = "") {
    // ffunc(this.suReport,strhandle + "DeleteGraphics", `${alias}`);
    //插入别名为 "QRcodeTag" 的文本框
    ffunc(this.suReport, strhandle + "callfunc", `112 \r\n x=2; y=2; width=66; height=66; alias=${alias}`);
    if (mode == 0) {
      ffunc(this.suReport, strhandle + "SetCellProp", `QRcodeTag \r\n borderThick \r\n 0`);
    }
    //刷新一下屏幕
    ffunc(this.suReport, strhandle + "SetRedrawAble", "true");
  }

  /**
   * 插入文本框
   * @param strhandle
   * @param alias 别名
   * @param mode 0：无边框
   */
  public insertCustomInput(alias, x, y, w, h, mode = 1, strhandle: string = "") {
    // ffunc(this.suReport,strhandle + "DeleteGraphics", `${alias}`);
    //插入别名为 "QRcodeTag" 的文本框
    ffunc(this.suReport, strhandle + "callfunc", `112 \r\n x=${x}; y=${y}; width=${w}; height=${h}; alias=${alias}`);
    if (mode == 0) {
      ffunc(this.suReport, strhandle + "SetCellProp", `${alias} \r\n borderThick \r\n 0`);
    }
    ffunc(this.suReport, strhandle + "SetCellProp", `${alias} \r\n vAlign \r\n middle`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${alias} \r\n align \r\n left`);
    ffunc(this.suReport, strhandle + "SetCellProp", `${alias} \r\n bgColor \r\n t`);
    //刷新一下屏幕
    ffunc(this.suReport, strhandle + "SetRedrawAble", "true");
  }


  /**
   * 设置文本框边框
   * @param alias 
   * @param borderThick 
   * @param strhandle 
   */
  public setBorderThick(alias, borderThick, strhandle: string = "") {
    ffunc(this.suReport, strhandle + "SetCellProp", `${alias} \r\n borderThick \r\n ${borderThick}`);
  }

  /**
   * 添加图片文本框元素
   * @param x
   * @param y
   * @param tWidth
   * @param tHeight
   * @param aliasName
   * @param imagebase64
   * @param sheetHandle
   */
  public addImageInputElement(x, y, tWidth, tHeight, aliasName, imagebase64, sheetHandle: string = "") {
    //插入别名为 "MyPic" 的文本框
    ffunc(this.suReport, sheetHandle + "callfunc", "112 \r\n x=" + x + "; y=" + y + "; width=" + tWidth + "; height=" + tHeight + "; alias=" + aliasName + "");
    //将其数据类型改成字符串型
    ffunc(this.suReport, sheetHandle + "SetCellProp", "" + aliasName + " \r\n dataType \r\n string");
    //添加图片显示掩码
    var id = ffunc(this.suReport, "Mask_Add", "string \r\n =picture()");
    //修改它的显示掩码
    ffunc(this.suReport, sheetHandle + "SetCellProp", aliasName + " \r\n maskId \r\n" + id);
    //设置值
    ffunc(this.suReport, sheetHandle + "SetCellData", aliasName + " \r\n" + imagebase64);
    //设置其它效果：背景色为透明、无边框
    ffunc(this.suReport, sheetHandle + "SetCellProp", aliasName + " \r\n bgColor \r\n T");
    ffunc(this.suReport, sheetHandle + "SetCellProp", aliasName + " \r\n borderThick \r\n 0");
    ffunc(this.suReport, sheetHandle + "SetCellProp", `${aliasName} \r\n align \r\n 1`);
    ffunc(this.suReport, sheetHandle + "SetCellProp", `${aliasName} \r\n vAlign \r\n 1`);
    //设置图片显示时的缩放模式
    ffunc(this.suReport, sheetHandle + "SetCellProp", aliasName + " \r\n ImageArrange \r\n stretchKeepRatio");


  }

  public setSignPic(strhandle, name, base64Url) {
    var id = ffunc(this.suReport, strhandle + "Mask_Add", "string \r\n =picture()");
    //修改它的显示掩码
    ffunc(this.suReport, strhandle + "SetCellProp", name + " \r\n maskId \r\n" + id);

    ffunc(this.suReport, strhandle + "SetCellData", name + " \r\n" + base64Url);
    ffunc(this.suReport, strhandle + "SetCellProp", name + " \r\n bgColor \r\n T");

    ffunc(this.suReport, strhandle + "SetCellProp", name + " \r\n datatype \r\n 1");
    ffunc(this.suReport, strhandle + "SetCellProp", name + " \r\n borderThick \r\n 0");

    ffunc(this.suReport, strhandle + "SetCellProp", name + " \r\n imageArrange \r\nfull");

    ffunc(this.suReport, strhandle + "SetRedrawAble", "true");
  }

  /**
   * 复制当前页
   * @param sheetName
   */
  public copySheet(sheetName = '') {
    const sheetIndex = ffunc(this.suReport, 'GetCurrentWorksheet', '');
    const strHandle = ffunc(this.suReport, "getHandle", sheetIndex);
    const sheetXmlStr = ffunc(this.suReport, strHandle + 'callfunc', `1074\r\n WorkSheet=${sheetIndex};isReturnContent=true;`);
    ffunc(this.suReport, strHandle + "appendWorksheet", sheetXmlStr);
    const newSheetIndex = ffunc(this.suReport, 'GetCurrentWorksheet', '');
    if (!this.isNull(sheetName)) {
      ffunc(this.suReport, strHandle + 'SetWorksheetName', newSheetIndex + " \r\n " + sheetName);
    }
    return newSheetIndex;
  }
  /**
   * 复制指定页
   * @param sheetXmlStr
   * @param sheetName
   */
  public copySheet2(sheetXmlStr, sheetName) {
    ffunc(this.suReport, "appendWorksheet", sheetXmlStr);
    const newSheetIndex = ffunc(this.suReport, 'GetCurrentWorksheet', '');
    ffunc(this.suReport, 'SetWorksheetName', newSheetIndex + " \r\n " + sheetName);
    return newSheetIndex;
  }

  /**
   * 清空所有报表
   */
  public clearSheet() {
    const sheetCount = Number(ffunc(this.suReport, "GetWorksheets", ''));
    for (let index = sheetCount - 1; index >= 0; index--) {
      ffunc(this.suReport, "DeleteWorksheet", index.toString());
    }
  }

  /**
   * 插入sheet页(添加成功后会自动变成当前活动的页)
   * @param sheetXml 待添加sheet串（注意：不是整个报表的串）
   * @param newSheetIndex 添加到哪里（默认-1，-1表示添加到末尾）
   * @param newSheetName 添加的名称
   */
  public insertSheet(sheetXml: string, newSheetIndex: number = -1, newSheetName: string = "", callback: any = undefined) {
    var sheetLen = this.getWorksheets();

    if (newSheetIndex < 0 || newSheetIndex > (sheetLen - 1)) {
      //如果超出范围，则添加到最后
      newSheetIndex = sheetLen;
    }
    //添加sheet页
    var m = this.appendWorksheet(`${sheetXml}`);
    if (m == "1") {//表示添加成功
      //获取添加sheet页的索引
      var index = this.getCurrentWorksheet();
      if (!this.isNull(newSheetName)) {
        //设置添加sheet页的名称
        this.setSheetName(index, newSheetName);
      }
      //设置添加sheet页的位置
      this.exchangeWorksheet(index, newSheetIndex);
      //设置活动页（由于appendWorksheet之后，活动页变成了新添加的sheet，之后又执行了exchangeWorksheet，就会导致当前活动页可能变了，所以此处重新设置活动页）
      this.setCurrentWorksheet(newSheetIndex);

      if (callback) {
        callback();
      }
    }
  }
  /**
   * 根据sheet页的名称获取SheetIndex
   * @param sheetName  sheet页的名称
   */
  public getSheetIndexBySheetName(sheetName: string) {
    let sheetIndex = -1;
    for (let index = 0; index < this.getWorksheets(); index++) {
      if (this.getWorksheetName(index) == sheetName) {
        sheetIndex = index;
        break;
      }
    }
    return sheetIndex;
  }
  /**
   * 合并单元格
   * @param row1
   * @param col1
   * @param row2
   * @param col2
   * @param strhandle
   */
  public merge(row1: number, col1: number, row2: number, col2: number, strhandle: string = '') {
    ffunc(this.suReport, strhandle + "Merge", `${row1} \r\n ${col1} \r\n ${row2} \r\n ${col2}`);
  }
  /**
   * 合并相同内容的单元格
   * @param row
   * @param col1
   * @param col2
   * @param strhandle
   */
  public mergeSameCol(row: number, col1: number, col2: number, strhandle: string = '') {
    ffunc(this.suReport, strhandle + "MergeSame", `row=${row};col1=${col1};col2=${col2}`);
  }
  /**
  * 合并相同内容的单元格
  * @param row
  * @param col1
  * @param col2
  * @param strhandle
  */
  public mergeSameRow(col: number, row1: number, row2: number, strhandle: string = '') {
    ffunc(this.suReport, strhandle + "MergeSame", `col=${col};row1=${row1};row2=${row2}`);
  }

  /**
   * 合并相同内容的单元格
   * @param col 示例："A,B,C"
   * @param row1 
   * @param row2 
   * @param strhandle 
   */
  public MergeSame(col: string, row1: number, row2: number, strhandle: string = '', isIgnoreNull: boolean = true, isDemergeFirst: boolean = false) {
    ffunc(this.suReport, strhandle + "MergeSame", `col=${col};row1=${row1};row2=${row2};isDemergeFirst=${isDemergeFirst};isIgnoreNull=${isIgnoreNull};`);
  }

  /**
   * 解除某个区域的合并
   * @param start A1
   * @param end B2
   * @param strhandle 
   */
  public DeMerg(start: string, end: string, strhandle: string = '') {
    ffunc(this.suReport, strhandle + 'deMerge', `${start}:${end}`);
  }

  public CloneArea1(para: string, row: number, strhandle: string = '') {
    ffunc(this.suReport, strhandle + "CloneArea", `${para} \r\n row=${row};`);
  }

  /**
   * 自定义菜单
   * @param content
   ** XML串
   ** <items>
   **   <item id="3103" text="热销" icon="buttons.zip#303.ico">
   **   <item id="KB3104" text="滞销产品" icon="buttons.zip#304.ico">
   **     <item id="31041" text="库存1" style="checkbox" checked="true" icon="buttons.zip#304.ico" detail="浮动的详细说明，可选"/>
   **     <item id="31042DM" text="库存2" enable="false" detail="浮动的详细说明，可选"/>
   **    </item>
   ** </items>
   ** 非XML的普通串
   ** var s = "id=40N01; text=男帽; icon=buttons.zip#301.ico; detail=夏季时装\r\n";
      s += "id=4002; text=时髦头巾; icon=buttons.zip#302.ico; detail=优惠直销"
   */
  public addMenu(content: string) {
    ffunc(this.suReport, "AddMenu", content);
  }

  public menuBeforePopup_Lock() {
    ffunc(this.suReport, "MenuBeforePopup_Lock", "");
  }

  public menuBeforePopup_UnLock() {
    ffunc(this.suReport, "MenuBeforePopup_UnLock", "");
  }
  /**
  * 关闭输入框
  */
  public closeEdit(para: boolean = true) {
    ffunc(this.suReport, "CloseEdit", para);
  }

  /**
   * 公式计算
   */
  public calculate(code = 163, strhandle: string = '') {
    ffunc(this.suReport, strhandle + 'callfunc', `${code}`);
  }

  /**
   * 设置工作表的某些属性
   * 格式为 "item1=value1;item2=value2;..." 的属性串
   */
  public SetProp(propStr: string) {
    ffunc(this.suReport, 'SetProp', propStr);
  }

  public blur() {
    ffunc(this.suReport, 'Blur', '');
  }

  /**
   * 执行工具栏上内容
   * @param cmd 
   * @param strhandle 
   */
   public callFunc(cmd, strhandle: string = '') {
    ffunc(this.suReport, strhandle + 'callfunc', `${cmd}`);
  }
}
